module.exports = __webpack_public_path__ + "img/darts-dark.532d9b7d.svg";